module.exports = __webpack_public_path__ + "static/img/xcx_yq.585ee15a.jpeg";